import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { ReportForm } from '../../components/ReportForm/ReportForm';
import { IReportUserPopupParams, useReportUserPresenter } from './ReportUserPopup.presenter';

export const ReportUserPopup: FC<ICommonPopupsProps<IReportUserPopupParams>> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useReportUserPresenter(props);
  useClosePopupOnNavigation(props.popupInstance);

  return (
    <Popup
      title={t('common_report')}
      isOpened
      handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
      onClose={presenter.onClose}
    >
      <ReportForm
        title={t('content_moderation_user')}
        onSubmit={presenter.onSubmit}
      />
    </Popup>
  );
});
